/* tslint:disable */
/* eslint-disable */

import { ReaderInlineDataFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type sharedMessageHelpers_user = {
    readonly activePromotion: {
        readonly promotionMeta: {
            readonly customBannerMessage: boolean | null;
            readonly desktopBannerMessage: string | null;
            readonly desktopBannerCta: string | null;
            readonly mobileBannerMessage: string | null;
            readonly mobileBannerCta: string | null;
        } | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"expiringPromoMessageHelpers_user" | "ExpiringPromoMessage_user">;
    readonly " $refType": "sharedMessageHelpers_user";
};
export type sharedMessageHelpers_user$data = sharedMessageHelpers_user;
export type sharedMessageHelpers_user$key = {
    readonly " $data"?: sharedMessageHelpers_user$data;
    readonly " $fragmentRefs": FragmentRefs<"sharedMessageHelpers_user">;
};



const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "sharedMessageHelpers_user"
};
(node as any).hash = 'c668f8267516a055a9a1a127d106e6bd';
export default node;
